import { AfterViewInit, Component, ComponentRef, EventEmitter, Input, Output, Type, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-card-product-order',
  styleUrls: ['./card-product-order.component.scss'],
  template: `
    <app-card *ngIf="showView" [cardClasses]="'mb-8 ' + cardClasses" [cardBodyClasses]="'pt-0 ' + cardBodyClasses" [header]="header" [cardHeaderTitle]="cardTitle">
      <ng-container cardBody>
        <ng-container #dynamicRef></ng-container>
      </ng-container>
    </app-card>
  `,
})
export class CardProductOrderComponent implements AfterViewInit {
  @ViewChild('dynamicRef', { read: ViewContainerRef }) dynamicRef!: ViewContainerRef;

  @Input() cardTitle = 'Pilih Produk';
  @Input() tableData!: Type<any>;
  @Input() cardClasses!: string;
  @Input() cardBodyClasses!: string;
  @Input() header = true;

  @Output() eventFromChild = new EventEmitter<{ eventName: string; value: any }>();

  componentRef!: ComponentRef<any>;
  showView = true;

  constructor() {}

  ngAfterViewInit(): void {
    this.componentRef = this.dynamicRef.createComponent(this.tableData);
    this.handleEventEmitterSubscription();
  }

  handleEventEmitterSubscription() {
    // Dynamically subscribe to EventEmitters of the loaded component
    const instance = this.componentRef.instance;
    Object.keys(instance).forEach((key) => {
      const property = instance[key];
      if (property instanceof EventEmitter) {
        property.subscribe((value: any) => this.eventFromChild.emit({ eventName: key, value }));
      }
    });
  }
}
